import { withTranslation } from "react-i18next";

import React from 'react';
import { Link } from 'react-router-dom';
import { Footer, Header } from '../Common';
import { AffiliatorSidebar } from '../Common/AffiliatorSidebar';
import Pagination from "react-js-pagination";
import { AffiliatorDashboardHeader } from '../Common/AffiliatorDashboardHeader';
import ProductsUpload from '../../Models/ProductsUpload';
import Affiliator from '../../Models/Affiliator';
import "bootstrap/scss/bootstrap.scss";
class CreateServiceLink extends React.Component {
    constructor(props) {
        super(props);
        let x = JSON.parse(localStorage.getItem('info'))
        if (x === null || x === '' || x.user_type_id !== 3) {
            alert(this.props.t('3'))
            this.props.history.push('/login/affiliator');
        };
        this.state = {
            _id: false,
            activePage: 1,
            itemsCountPerPage: 10,
            pageRangeDisplayed: 5,
            itemsCountPerPage2: 10,
            pageRangeDisplayed2: 5,
            total: [],
            pageNumber: 1,
            totalAll: [],
            categories: [],
            affiliatorCommission: [],
            seller_name: '',
            category: '',
            affCommission: '',
            autoPayment: '',
            affilitedProducts: [],
            selectedAffilitedProducts: [],

        };
        this.getCategories();
        this.getAffiliatorCommission();
    }

    componentDidMount() {
        let x = JSON.parse(localStorage.getItem('info'));
        window.scrollTo(0, 0)
        ProductsUpload.getAllAffiliatedProducts(x.id, x.first_name, 1).then(res => {
            this.setState({
                affilitedProducts: res.data.payload,
                totalAll: res.data.total,
                pageRangeDisplayed: this.state.pageRangeDisplayed,
                itemsCountPerPage: this.state.itemsCountPerPage
            })
        })
    }

    getCategories() {
        ProductsUpload.getCategoryDropdown().then(res => {
            this.setState({ categories: res.data.categories })
        })
    }

    getAffiliatorCommission() {
        ProductsUpload.getCategory().then(res => {
            this.setState({ affiliatorCommission: res.data.aff_points })
        })
    }

    updateValue(type, e) {
        var obj = {};
        obj[type] = e.target.type === "checkbox" ? e.target.checked : e.target.value;
        this.setState(obj);
    }

    handleSubmit(e) {
        console.log('hello', this.state.seller_name)
        let x = JSON.parse(localStorage.getItem('info'));
        e.preventDefault()
        let data = {
            seller_name: this.state.seller_name,
            category_id: this.refs.category.value,
            commission_level: this.refs.affCommission.value,
            autoPayment: parseInt(this.refs.autoPayment.value),
            layer: this.state.pageNumber,
            aff_id: x.id,
        }
        Affiliator.getAffiliatedProducts(data).then(res => {
            console.log(res.data)
            if (res.data.status === 200) {
                this.setState({
                    selectedAffilitedProducts: res.data.payload,
                    total: res.data.total,
                    pageRangeDisplayed2: this.state.pageRangeDisplayed2,
                    itemsCountPerPage2: this.state.itemsCountPerPage2
                })
            }
        })
    }

    handlePageChangeAll(pageNumber) {
        let x = JSON.parse(localStorage.getItem('info'));
        ProductsUpload.getAllAffiliatedProducts(x.id, x.first_name, pageNumber).then(res => {

            console.log('all', res.data)
            if (res.data.payload != null) {
                this.setState({
                    affilitedProducts: res.data.payload,
                    totalAll: res.data.total,
                    activePage: pageNumber,
                    pageRangeDisplayed: this.state.pageRangeDisplayed,
                    itemsCountPerPage: this.state.itemsCountPerPage
                })
            }
        })
    }

    handlePageChange(pageNumber) {
        let x = JSON.parse(localStorage.getItem('info'));
        let data = {
            seller_name: this.state.seller_name,
            category_id: this.refs.category.value,
            commission_level: this.refs.affCommission.value,
            autoPayment: parseInt(this.refs.autoPayment.value),
            layer: pageNumber,
            aff_id: x.id
        }
        Affiliator.getAffiliatedProducts(data, pageNumber).then(res => {
            console.log(res.data)
            if (res.data.status === 200) {
                this.setState({
                    selectedAffilitedProducts: res.data.payload,
                    total: res.data.total,
                    pageRangeDisplayed2: this.state.pageRangeDisplayed2,
                    itemsCountPerPage2: this.state.itemsCountPerPage2
                })
            }
        })
    }

    handleClick(web_link, line_link, aff_id, product_id, e) {
        e.preventDefault();
        let data = {
            line_link: line_link,
            web_link: web_link,
            aff_id: aff_id,
            pro_id: product_id
        }
        Affiliator.saveAffiliatedProducts(data).then(res => {
            // this.setState({})
            if (res.data.status === 200) {
                alert(this.props.t('0'))
                this.props.history.push('/affiliator-individual-products')
            } else {
                alert(this.props.t('4'))
            }
        })

    }

    pagination() {
        if (this.state.total != 0) {
            if (this.state.total > 10) {
                return (
                    <div className="row">
                        <div className="col-md-3"></div>
                        <div className="col-md-6 ">
                            <Pagination
                                hideNavigation
                                activePage={this.state.activePage}
                                itemsCountPerPage={this.state.itemsCountPerPage2}
                                totalItemsCount={this.state.total}
                                pageRangeDisplayed={this.state.pageRangeDisplayed2}
                                onChange={this.handlePageChange.bind(this)}
                            />
                        </div>
                        <div className="col-md-3"></div>
                    </div>
                )
            }
        } else {
            if (this.state.totalAll > 10) {
                return (
                    <div className="row">
                        <div className="col-md-3"></div>
                        <div className="col-md-6 ">
                            <Pagination
                                hideNavigation
                                activePage={this.state.activePage}
                                itemsCountPerPage={this.state.itemsCountPerPage}
                                totalItemsCount={this.state.totalAll}
                                pageRangeDisplayed={this.state.pageRangeDisplayed}
                                onChange={this.handlePageChangeAll.bind(this)}
                            />
                        </div>
                        <div className="col-md-3"></div>
                    </div>
                )
            }
        }
    }

    productShow() {
        let x = JSON.parse(localStorage.getItem('info'));
        const isMobile = window.innerWidth <= 500;
        if (isMobile) {
            if (this.state.selectedAffilitedProducts != '') {
                return (
                    this.state.selectedAffilitedProducts.map(affi =>
                        <div className="row pt-2" >
                            <div className="">
                                <div className="col-md-12">
                                    <div className="row">
                                        <div className="col-4">
                                            <span style={{ fontSize: '14px' }} >{this.props.t('15')}</span>
                                        </div>
                                        <div className="col-8 pl-0">
                                            <Link to={{
                                                pathname: `/categories-details/${affi.id}`,
                                                state: { id: affi.id }
                                            }} className="text-left gray" style={{ textDecoration: 'none', fontSize: '14px' }}>
                                                {affi.title}
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-12">
                                    <div className="row">
                                        <div className="col-4" >{this.props.t('23')}</div>
                                        <div className="col-8 pl-0">{parseInt(affi.price)}</div>
                                    </div>
                                </div>

                                <div className="col-md-12">
                                    <div className="row">
                                        <div className="col-4" >{this.props.t('7')}</div>
                                        <div className="col-8 pl-0">{parseInt(affi.affiliator_commission_amount)}</div>
                                    </div>
                                </div>

                                <div className="col-md-12">
                                    <div style={{ fontSize: '12px' }} className="row mb-2">
                                        <div className="col-4">{this.props.t('24')}</div>
                                        {(() => {
                                            if (affi.self_affiliate == 'NO') {
                                                return (
                                                    <div className="col-8 pl-0" style={{ color: 'red' }}>{this.props.t('37')}</div>
                                                )
                                            } else if (affi.self_affiliate == 'YES') {
                                                return (
                                                    <div className="col-8 pl-0" style={{ color: 'green' }}>{this.props.t('44')}</div>
                                                )
                                            }
                                        })()}
                                    </div>
                                </div>
                                <div className="col">
                                    <button className="" style={{ width: '100%', backgroundColor: "#7ea9e6", borderColor: "#6290d1", height: '35px', borderRadius: '5px', color: '#fff', boxShadow: "#ffffff4d 0px 1px 0px 0px inset" }} onClick={this.handleClick.bind(this, affi.web_link, affi.line_link, x.id, affi.id)}>
                                        {this.props.t('16')}
                                        </button>
                                </div>
                                <div className="col">
                                    <hr />
                                </div>
                            </div>
                        </div>
                    )
                )
            } else {
                return (
                    this.state.affilitedProducts.map(affi =>
                        <div className="row pt-2" >
                            <div className="">
                                <div className="col-md-12">
                                    <div className="row">
                                        <div className="col-4">
                                            <span style={{ fontSize: '14px' }} >{this.props.t('15')}</span>
                                        </div>
                                        <div className="col-8 pl-0">
                                            <Link to={{
                                                pathname: `/categories-details/${affi.id}`,
                                                state: { id: affi.id }
                                            }} className="text-left gray" style={{ textDecoration: 'none', fontSize: '14px' }}>
                                                {affi.title}
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-12">
                                    <div className="row">
                                        <div className="col-4" >{this.props.t('23')}</div>
                                        <div className="col-8 pl-0">{parseInt(affi.price)}</div>
                                    </div>
                                </div>

                                <div className="col-md-12">
                                    <div className="row">
                                        <div className="col-4" >{this.props.t('7')}</div>
                                        <div className="col-8 pl-0">{parseInt(affi.affiliator_commission_amount)}</div>
                                    </div>
                                </div>

                                <div className="col-md-12">
                                    <div style={{ fontSize: '12px' }} className="row mb-2">
                                        <div className="col-4">{this.props.t('24')}</div>
                                        {(() => {
                                            if (affi.self_affiliate == 'NO') {
                                                return (
                                                    <div className="col-8 pl-0" style={{ color: 'red' }}>{this.props.t('37')}</div>
                                                )
                                            } else if (affi.self_affiliate == 'YES') {
                                                return (
                                                    <div className="col-8 pl-0" style={{ color: 'green' }}>{this.props.t('44')}</div>
                                                )
                                            }
                                        })()}
                                    </div>
                                </div>
                                <div className="col">
                                    <button className="" style={{ width: '100%', backgroundColor: "#7ea9e6", borderColor: "#6290d1", height: '35px', borderRadius: '5px', color: '#fff', boxShadow: "#ffffff4d 0px 1px 0px 0px inset" }} onClick={this.handleClick.bind(this, affi.web_link, affi.line_link, x.id, affi.id)}>
                                        {this.props.t('16')}
                                        </button>
                                </div>
                                <div className="col">
                                    <hr />
                                </div>
                            </div>
                        </div>
                    )
                )
            }
        }
        else {
            if (this.state.total === 0) {
                return (
                    <div className="">No search product found</div>
                )
            } else if (this.state.selectedAffilitedProducts.length !== 0) {
                return (
                    this.state.selectedAffilitedProducts.map(affi =>
                        <div className="pt-2">
                            <div className="row">
                                <div className="col-md-9">
                                    <div className="row">
                                        <div className="col-md-3">
                                            <span style={{ fontSize: '14px' }} >{this.props.t('15')}</span>
                                        </div>
                                        <div className="col-md-9">
                                            <Link to={{
                                                pathname: `/categories-details/${affi.id}`,
                                                state: { id: affi.id }
                                            }} className=" text-left" style={{ textDecoration: 'none', fontSize: '14px' }}>
                                                {affi.title}
                                            </Link>
                                        </div>

                                    </div>
                                    <div className="row">
                                        <div className="col-md-6"  >
                                            <span style={{ marginRight: "80px", fontSize: '14px' }}>{this.props.t('23')}</span>
                                            {parseInt(affi.price)}
                                        </div>
                                        <div className="col-md-6">
                                            <span style={{ marginRight: "51px", fontSize: '14px' }}>{this.props.t('7')}</span>
                                            {parseInt(affi.affiliator_commission_amount)}
                                        </div>

                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div style={{ fontSize: '12px' }} className="mb-2">
                                        <span style={{ marginRight: "0px" }}>{this.props.t('24')}</span>
                                        {(() => {
                                            if (affi.self_affiliate == 'YES') {
                                                return (
                                                    <span style={{ color: 'green' }}>{this.props.t('44')}</span>
                                                )
                                            } else if (affi.self_affiliate == 'NO') {
                                                return (
                                                    <span style={{ color: 'red' }}>{this.props.t('37')}</span>
                                                )
                                            }
                                        })()}
                                    </div>
                                    <button className="" style={{ width: '100%', backgroundColor: "#7ea9e6", borderColor: "#6290d1", height: '35px', borderRadius: '5px', color: '#fff', boxShadow: "#ffffff4d 0px 1px 0px 0px inset" }} onClick={this.handleClick.bind(this, affi.web_link, affi.line_link, x.id, affi.id)}>
                                        {this.props.t('16')}
                                </button>
                                </div>
                            </div>
                            <hr />
                        </div>
                    )
                )
            } else {
                console.log('all')
                return (
                    this.state.affilitedProducts.map(affi =>
                        <div className="pt-2">
                            <div className="row">
                                <div className="col-md-9">
                                    <div className="row">
                                        <div className="col-md-3">
                                            <span style={{ fontSize: '14px' }} >{this.props.t('15')}</span>
                                        </div>
                                        <div className="col-md-9">
                                            <Link to={{
                                                pathname: `/categories-details/${affi.id}`,
                                                state: { id: affi.id }
                                            }} className=" text-left" style={{ textDecoration: 'none', fontSize: '14px' }}>
                                                {affi.title}
                                            </Link>
                                        </div>

                                    </div>
                                    <div className="row">
                                        <div className="col-md-6"  >
                                            <span style={{ marginRight: "80px", fontSize: '14px' }}>{this.props.t('23')}</span>
                                            {parseInt(affi.price)}
                                        </div>
                                        <div className="col-md-6">
                                            <span style={{ marginRight: "51px", fontSize: '14px' }}>{this.props.t('7')}</span>
                                            {parseInt(affi.affiliator_commission_amount)}
                                        </div>

                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div style={{ fontSize: '12px' }} className="mb-2">
                                        <span style={{ marginRight: "0px" }}>{this.props.t('24')}</span>
                                        {(() => {
                                            if (affi.self_affiliate == 'YES') {
                                                return (
                                                    <span style={{ color: 'green' }}>{this.props.t('44')}</span>
                                                )
                                            } else if (affi.self_affiliate == 'NO') {
                                                return (
                                                    <span style={{ color: 'red' }}>{this.props.t('37')}</span>
                                                )
                                            }
                                        })()}
                                    </div>
                                    <button className="" style={{ width: '100%', backgroundColor: "#7ea9e6", borderColor: "#6290d1", height: '35px', borderRadius: '5px', color: '#fff', boxShadow: "#ffffff4d 0px 1px 0px 0px inset" }} onClick={this.handleClick.bind(this, affi.web_link, affi.line_link, x.id, affi.id)}>
                                        {this.props.t('16')}
                                </button>
                                </div>
                            </div>
                            <hr />
                        </div>
                    )
                )
            }
        }

    }

    render() {
        let x = JSON.parse(localStorage.getItem('info'));
        const isMobile = window.innerWidth <= 500;
        const isDesktop = window.innerWidth >= 500;
        if (isMobile) {
            return (
                <div>
                    <Header />
                    <div className="col-md-12 tr_blank_medium mt-5 pt-4"></div>
                    <div className="col-md-12 tr_blank_medium mt-5 "></div>
                    <div className="container-fluid request_fonts">
                        <div className="mb-3 input_name guide_text" style={{ width: '100%', fontSize: "20px " }}>
                            {this.props.t('1')}
                        </div>
                        <div>
                            <form onSubmit={this.handleSubmit.bind(this)}>
                                <div className="pb-2">
                                    <div className="col-md-12 mb-3" style={{ borderBottom: '1px solid #ccc' }} onChange={this.handleSubmit.bind(this)}>
                                        <div className="row">
                                            <div className="col-11 pl-0">
                                                <input type="text" className="catagory_select" style={{ border: '0px' }} placeholder={this.props.t('11')} value={this.state.seller_name} onChange={this.updateValue.bind(this, 'seller_name')} />
                                            </div>
                                            <button type="submit" className="col-1 pr-0 justify-content-end" style={{ border: '0px solid #ccc', backgroundColor: 'white', width: '40px', height: '30px' }}><i className="fas fa-search"></i></button>
                                        </div>
                                    </div>
                                    <div className="row pt-1">
                                        <div className="col-4  pt-1 pr-1 pl-0">
                                            <div></div>
                                            <select className="catagory_select " ref="affCommission" onChange={this.handleSubmit.bind(this)}>
                                                <option value="">{this.props.t('5')} </option>
                                                {this.state.affiliatorCommission.map(rp =>
                                                    <option value={rp.id} key={rp.id}>
                                                        {rp.point_value}% {this.props.t('41')}
                                            </option>
                                                )}
                                            </select>
                                        </div>
                                        <div className="col-4 pt-1 pl-0">
                                            <div></div>
                                            <select className="catagory_select " ref="autoPayment" onChange={this.handleSubmit.bind(this)}>
                                                <option value="">{this.props.t('35')} </option>
                                                <option value={1}>{this.props.t('31')}</option>
                                                <option value={2}>{this.props.t('32')}</option>
                                                )}
                                            </select>
                                        </div>
                                        <div className="col-4 pt-1 pr-1">
                                            <div style={{display: "none"}}>
                                                <select className="catagory_select" ref="category" onChange={this.handleSubmit.bind(this)}>
                                                    <option value=""> {this.props.t('12')}</option>
                                                    {this.state.categories.map(cat =>
                                                        <option value={cat.id} key={cat.id} >
                                                            {cat.cat_name}
                                                        </option>
                                                    )}
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                        {this.productShow()}

                        {this.pagination()}
                    </div>
                    <Footer />
                </div>
            )
        } else {
            return (
                <div>
                    <Header />
                    <div className="col-md-12 tr_blank_medium mt-5 pt-4"></div>
                    <div className="col-md-12 tr_blank_medium mt-5 "></div>
                    <div className="container-fluid">
                        <div className="container">
                            <div className="col-md-12">
                                <div className="row">
                                    <div className="col-md-4 input_name small-hidden">
                                        <AffiliatorSidebar />
                                    </div>
                                    <div className="col-md-8">
                                        <div className="mb-3 input_name big_font guide_text pages_headers" style={{ width: '100%' }}>
                                            {this.props.t('1')}
                                        </div>
                                        <form >
                                            <div className="col-md-12 mb-3" style={{ borderBottom: '1px solid #ccc' }} onChange={this.handleSubmit.bind(this)}>
                                                <div className="row" onSubmit={this.handleSubmit.bind(this)}>
                                                    <div className="col-md-11 pl-0">
                                                        <input type="text" className="catagory_select" style={{ border: '0px' }} placeholder={this.props.t('11')} value={this.state.seller_name} onChange={this.updateValue.bind(this, 'seller_name')} />
                                                    </div>
                                                    <button type="submit" className="col-md-1 pr-0 justify-content-end" style={{ border: '0px solid #ccc', backgroundColor: 'white', width: '40px', height: '30px' }}><i className="fas fa-search"></i></button>
                                                </div>
                                            </div>
                                            <div className="row pb-2">
                                                <div className="col-md-4 pt-1">
                                                    <div></div>
                                                    <select className="catagory_select " ref="affCommission" onChange={this.handleSubmit.bind(this)}>
                                                        <option value="">{this.props.t('5')} </option>
                                                        {this.state.affiliatorCommission.map(rp =>
                                                            <option value={rp.id} key={rp.id}>
                                                                {rp.point_value}% {this.props.t('41')}
                                                        </option>
                                                        )}
                                                    </select>
                                                </div>
                                                <div className="col-md-4 pt-1">
                                                    <div></div>
                                                    <select className="catagory_select " ref="autoPayment" onChange={this.handleSubmit.bind(this)}>
                                                        <option value="">{this.props.t('35')} </option>
                                                        <option value={1}>{this.props.t('31')}</option>
                                                        <option value={2}>{this.props.t('32')}</option>
                                                        )}
                                                    </select>
                                                </div>
                                                <div className="col-md-4 pt-1">
                                                    <div  style={{display: "none"}}>
                                                        <select className="catagory_select" ref="category" onChange={this.handleSubmit.bind(this)}>
                                                            <option value=""> {this.props.t('12')}</option>
                                                            {this.state.categories.map(cat =>
                                                                <option value={cat.id} key={cat.id} >
                                                                    {cat.cat_name}
                                                                </option>
                                                            )}
                                                        </select>
                                                    </div>
                                                </div>
                                                {/* <div className="col-md-2  " >
                                                    <button type="submit" className="" style={{ width: '100%', backgroundColor: "#7ea9e6", borderColor: "#6290d1", height: '35px', borderRadius: '5px', color: '#fff', boxShadow: "#ffffff4d 0px 1px 0px 0px inset" }} > {this.props.t('43')} </button>
                                                </div> */}
                                            </div>
                                        </form>
                                        {this.productShow()}

                                        {this.pagination()}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <Footer />
                </div>
            )
        }

    }
}
export { CreateServiceLink }


 CreateServiceLink = withTranslation('src_Components_Affiliator_CreateServiceLink')(CreateServiceLink);
